import { Drawer as ChakraDrawer, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay } from "@chakra-ui/react"

export default function Drawer({ title, children, loading = false, onClose = () => {}, ...props }){

    const onCloseDrawer = () => loading ? null : onClose()

    return(
    <ChakraDrawer onClose={onCloseDrawer} {...props}>
        <DrawerOverlay />
        <DrawerContent>
            <DrawerCloseButton isDisabled={loading} />
            <DrawerHeader children={title} />
            { children }
        </DrawerContent>
    </ChakraDrawer>
    )
}